<template>
  <el-dialog :visible.sync="dialogFormVisible" @close="closeHandler" :modal="true" center>
    <div slot="title">
      {{ title }}人员信息
    </div>
    <el-form :model="form" :rules="settingAccountRules" ref="settingAccountform">
      <el-form-item label="所属组织" :label-width="formLabelWidth">
        <el-input :value="association.name" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
        <el-input v-model="form.name" autocomplete="off" :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="账号" :label-width="formLabelWidth" prop="username">
        <el-input v-model="form.username" autocomplete="off" :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">
        <el-input v-model="form.phone" autocomplete="off" :maxlength="11"></el-input>
      </el-form-item>
      <el-form-item label="初始密码" :label-width="formLabelWidth" prop="initPwd" v-if="hasInitPwdRow">
        <el-input v-model="form.initPwd" autocomplete="off" :minlength="6"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitValidate">确 定</el-button>
      <el-button @click="dialogFormVisible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { addUser, editUser, allUsers, editNormal, addNormal } from '@/api'
export default {

  watch: {
    isShow (value) {
      this.dialogFormVisible = this.isShow
      if (this.type === 'add') {
        this.title = '添加'
        this.form = {
          name: '',
          username: '',
          phone: '',
          initPwd: '123456'
        }
      }
      if (this.type === 'edit') {
        this.title = '修改'
        this.form.id = this.item.id
        this.form.name = this.item.name
        this.form.username = this.item.username
        this.form.phone = this.item.phone
        this.form.initPwd = this.item.initPwd
      }
    },
    dialogFormVisible (newVal, oldVal) {
      if (!newVal) {
        this.$refs['settingAccountform'].resetFields()
      }
    }
  },
  computed: {
    hasInitPwdRow () {
      if (this.item.id) {
        return false
      } else {
        return true
      }
    }
  },
  data () {
    return {
      dialogFormVisible: this.isShow,
      title: '',
      form: {
        name: '',
        username: '',
        phone: '',
        initPwd: '123456'
      },
      settingAccountRules: {
        name: [
          { trigger: 'blur', required: true, message: '请输入姓名' },
          { max: 20, message: '姓名长度不能大于20', trigger: 'blur' },
          { trigger: 'blur', pattern: /^[\u4e00-\u9fa5 \d a-zA-Z]{1,20}$/isu, message: '姓名需为文字、数字或字母' }
        ],
        username: [
          { trigger: 'blur', required: true, message: '请输入账号' },
          { max: 20, message: '账号长度不能大于20', trigger: 'blur' },
          { trigger: 'blur', pattern: /[A-Za-z0-9]{1,20}/, message: '账号格式错误' }
        ],
        phone: [
          { trigger: 'blur', required: true, message: '请输入手机号' },
          { trigger: 'blur', len: 11, message: '手机号长度需为11位' },
          { trigger: 'blur', pattern: /1\d{10}/, message: '手机号格式错误' }
        ],
        initPwd: [
          { trigger: 'blur', required: true, message: '请输入初始密码' },
          { min: 6, message: '初始密码长度不能小于6', trigger: 'blur' }
        ]
      },
      formLabelWidth: '120px'
    }
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    association: {
      type: Object,
      default: () => {
        return {
          name: ''
        }
      }
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    closeHandler () {
      this.$emit('DialogClose')
    },
    submitValidate () {
      this.$refs['settingAccountform'].validate((valid) => {
        if (valid) {
          this.submit()
        }
      })
    },
    async submit () {
      try {
        if (this.type === 'add') {
          let res
          if (Number.parseInt(this.association.channel) === 0) {
            res = await addUser(this, this.form, this.association.channel)
          } else {
            res = await addNormal(this, this.form, this.association.channel)
          }
          if (res && Number.parseInt(res.ret) === 1) {
            this.$message.success('新增成功')
            allUsers(this, { channel: this.association.channel })
            this.dialogFormVisible = false
          } else {
            this.$message.error(res.msg)
          }
        }
        if (this.type === 'edit') {
          let res
          if (Number.parseInt(this.association.channel) === 0) {
            res = await editUser(this, this.form, this.association.channel)
          } else {
            res = await editNormal(this, this.form, this.association.channel)
          }
          if (res && Number.parseInt(res.ret) === 1) {
            this.$message.success('修改成功')
            allUsers(this, { channel: this.association.channel })
            this.dialogFormVisible = false
          } else {
            this.$message.error(res.msg)
          }
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style>

</style>
